var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCups3EmptyUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 24,
    viewBox: "0 0 58 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89016 23.7808L6.14932 21.315L12.28 18.0274L12.6255 14.7397L2.83202 5.6986L3.17757 2.41093H8.13621L8.30899 0.76709H15.747H23.1849L23.0122 2.41093H27.9708L27.6253 5.6986L15.9313 14.7397L15.5857 18.0274L21.0253 21.315L20.7661 23.7808H13.3281H5.89016ZM8.78988 4.05476H5.48412L5.39773 4.87668L8.44434 7.34243L8.78988 4.05476ZM22.0129 4.05476H25.3187L25.2323 4.87668L21.6674 7.34243L22.0129 4.05476Z",
    fill: "#FFB800"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_843_20540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 31,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2532 0.767123V0.76709H42.9377V23.7808H22.6205L22.8797 21.3151L17.4402 18.0274L17.7857 14.7397L29.4797 5.69863L29.8252 2.41096H24.8666L25.0394 0.767123H17.6014H12.2532ZM12.2532 12.684V19.0362L14.1344 18.0274L14.4799 14.7397L12.2532 12.684Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_843_20540)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5667 23.7808L20.8258 21.315L26.9565 18.0274L27.302 14.7397L17.5085 5.6986L17.8541 2.41093H22.8127L22.9855 0.76709H30.4235H37.8614L37.6887 2.41093H42.6473L42.3018 5.6986L30.6078 14.7397L30.2622 18.0274L35.7018 21.315L35.4426 23.7808H28.0046H20.5667ZM23.4664 4.05476H20.1606L20.0742 4.87668L23.1209 7.34243L23.4664 4.05476ZM36.6895 4.05476H39.9952L39.9088 4.87668L36.3439 7.34243L36.6895 4.05476Z",
    fill: "#D9D7CF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_843_20540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 0,
    width: 32,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4995 0.767123V0.76709H57.1841V23.7808H37.4148L37.674 21.3151L32.2345 18.0274L32.58 14.7397L44.274 5.69863L44.6195 2.41096H39.6609L39.8337 0.767123H32.3957H26.4995ZM26.4995 12.1782V19.3301L28.9287 18.0274L29.2742 14.7397L26.4995 12.1782Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_843_20540)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.813 23.7808L35.0722 21.315L41.2028 18.0274L41.5484 14.7397L31.7549 5.6986L32.1004 2.41093H37.0591L37.2318 0.76709H44.6698H52.1078L51.935 2.41093H56.8937L56.5481 5.6986L44.8541 14.7397L44.5086 18.0274L49.9481 21.315L49.689 23.7808H42.251H34.813ZM37.7127 4.05476H34.407L34.3206 4.87668L37.3672 7.34243L37.7127 4.05476ZM50.9358 4.05476H54.2416L54.1552 4.87668L50.5902 7.34243L50.9358 4.05476Z",
    fill: "#E77238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCups3EmptyUpdated);
export default __webpack_public_path__ + "static/media/cups-3-empty-updated.5bad04c8e5c42373dac6c680b8b97383.svg";
export { ForwardRef as ReactComponent };